import styled from 'styled-components'
import React from 'react'
import PropTypes from 'prop-types'
import { Box, Text, getPaletteColor } from 'pcln-design-system'

const StyledPricingDisclosure = styled(Box)`
  font-weight: 500;
  line-height: 1.2;
  color: ${getPaletteColor('text.light')};
  margin: 3px 0 5px;
`

export default function PricingDisclosure({ disclosure }) {
  return (
    disclosure && (
      <StyledPricingDisclosure data-testid='pricing-disclosure'>
        {disclosure.split('\n').map((line, index) => (
          <Text.p m={0} key={index} fontSize={['10px', 0]}>
            {line}
          </Text.p>
        ))}
      </StyledPricingDisclosure>
    )
  )
}

PricingDisclosure.defaultProps = {
  disclosure: null,
}

PricingDisclosure.propTypes = {
  disclosure: PropTypes.string,
}
